import { Table, Modal, Button, Spin, Avatar, Tag, Descriptions } from "antd";
import axios from "axios";
import { useState, useEffect } from "react";
import { MdPersonAdd, MdOutlineBedroomParent } from "react-icons/md";
import { FaHospitalUser, FaEdit } from "react-icons/fa";
import { RiEmpathizeLine, RiAdminLine } from "react-icons/ri";
import { BsFillBookmarkCheckFill } from "react-icons/bs";
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../../../api";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const FrontPage = () => {
  const [loading, setLoading] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [agents, setAgents] = useState([]);
  const [managers, setmanagers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [testorders, settestorders] = useState([]);
  const [patients, setPatientsList] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [summaryCounts, setSummaryCounts] = useState({});

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalData, setModalData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalColumns, setModalColumns] = useState([]);
  const [currentView, setCurrentView] = useState("table");
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [modalFilterText, setModalFilterText] = useState("");

  // const { patients: patientsFromRedux } = useSelector((store) => store.data.patients);
  const { dashboard: { data } } = useSelector((store) => store.data);

  const navigate = useNavigate();
  const { data: { user }, } = useSelector((state) => state.auth);
  const isManager = user?.userType === "manager";

  const fetchSummaryCounts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/dashboard/summary`);
      setSummaryCounts(response.data || {});
    } catch (error) {
      console.error("Error fetching summary counts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isManager) {
      navigate('/');
      return;
    }
    fetchSummaryCounts();
  }, [isManager, navigate]);


  const fetchAgents = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/agents`);
      setAgents(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching agents:", error);
      return [];
    }
  };

  const fetchDoctors = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/doctors`);
      setDoctors(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching doctors:", error);
      return [];
    }
  };

  const fetchAdmins = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin`);
      setAdmins(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching admins:", error);
      return [];
    }
  };

  const feltchPatients = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/patients`);
      // console.log("Fetched patients:", response.data.patients);
      setPatientsList(response.data.patients);
      return response.data.patients;
    } catch (error) {
      toast.error("Failed to fetch patients");
      console.error("Error fetching patients:", error);
      return [];
    }
  };

  const fetchmanagers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/managers`);
      setmanagers(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching managers:", error);
      return [];
    }
  };

  const fetchtestorders = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/testorders?depth=2`);
      settestorders(response.data);
      // console.log("Fetched testorders:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching testorders:", error);
      return [];
    }
  };


  const showModal = async (title, type) => {
    setIsModalVisible(true);
    setModalTitle(title);
    setModalLoading(true);
    setCurrentView("table");
    setSelectedRecord(null);

    let columns = [];
    let data = [];

    const ensureData = async (kind) => {
      switch (kind) {
        case "doctor":
          return doctors.length > 0 ? doctors : await fetchDoctors();
        case "manager":
          return managers.length > 0 ? managers : await fetchmanagers();
        case "agent":
          return agents.length > 0 ? agents : await fetchAgents();
        case "admin":
          return admins.length > 0 ? admins : await fetchAdmins();
        case "testorder":
          return testorders.length > 0 ? testorders : await fetchtestorders();
        case "patient":
          return patients.length > 0 ? patients : await feltchPatients();
        default:
          return [];
      }
    };

    switch (type) {
      case "doctor":
        columns = [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Avatar src={text || "/user.png"} />
          },
          { title: "ID", dataIndex: "docID", key: "docID" },
          { title: "Name", dataIndex: "docName", key: "docName" },
          { title: "Department", dataIndex: "department", key: "department" },
          { title: "Email", dataIndex: "email", key: "email" },
          { title: "Mobile", dataIndex: "mobile", key: "mobile" },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button type="primary" onClick={() => viewDetails(record, "doctor")}>
                View Details
              </Button>
            )
          },
        ];
        data = await ensureData("doctor");
        break;
      case "manager":
        columns = [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Avatar src={text || "/user.png"} />
          },
          { title: "ID", dataIndex: "managerID", key: "managerID" },
          { title: "Name", dataIndex: "managerName", key: "managerName" },
          { title: "Email", dataIndex: "email", key: "email" },
          { title: "Mobile", dataIndex: "mobile", key: "mobile" },
          { title: "Education", dataIndex: "education", key: "education" },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button type="primary" onClick={() => viewDetails(record, "manager")}>
                View Details
              </Button>
            )
          },
        ];
        data = await ensureData("manager");
        break;
      case "agent":
        columns = [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Avatar src={text || "/user.png"} />
          },
          {
            title: "ID",
            dataIndex: "agentID",
            key: "agentID"
          },
          {
            title: "Name",
            dataIndex: "name",
            key: "name"
          },
          {
            title: "Email",
            dataIndex: "email",
            key: "email"
          },
          {
            title: "Mobile",
            dataIndex: "mobile",
            key: "mobile"
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
              <Tag color={status === 'active' ? 'green' : 'red'}>
                {status?.toUpperCase() || "ACTIVE"}
              </Tag>
            )
          },
          // { title: "Commission Rate", dataIndex: "commissionRate", key: "commissionRate", render: (rate) => `${rate || 0}%` },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button type="primary" onClick={() => viewDetails(record, "agent")}>
                View Details
              </Button>
            )
          },
        ];
        data = await ensureData("agent");
        break;
      case "admin":
        columns = [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Avatar src={text || "/user.png"} />
          },
          { title: "ID", dataIndex: "adminID", key: "adminID" },
          { title: "Name", dataIndex: "adminName", key: "adminName" },
          { title: "Email", dataIndex: "email", key: "email" },
          { title: "Mobile", dataIndex: "mobile", key: "mobile" },
          { title: "Education", dataIndex: "education", key: "education" },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button type="primary" onClick={() => viewDetails(record, "admin")}>
                View Details
              </Button>
            )
          },
        ];
        data = await ensureData("admin");
        break;
      case "testorder":
        columns = [
          { title: "Patient Name", dataIndex: "patient", key: "patient", render: (patient) => patient?.patientName || "N/A" },
          { title: "Age", dataIndex: "patient", key: "patient", render: (patient) => patient?.age || "N/A" },
          { title: "Gender", dataIndex: "patient", key: "patient", render: (patient) => patient?.gender || "N/A" },
          { title: "Doctor", dataIndex: "doctor", key: "doctor", render: (doctor) => doctor?.docName || "N/A" },
          { title: "Date", dataIndex: "date", key: "date" },
          { title: "Time", dataIndex: "time", key: "time" },
          { title: "Total Amount", dataIndex: "totalAmount", key: "totalAmount", render: (amount) => `₹${amount}` },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <Button type="primary" onClick={() => viewDetails(record, "testorder")}>
                View Details
              </Button>
            )
          },
        ];
        data = await ensureData("testorder");
        break;
      case "patient":
        columns = [
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Avatar src={text || "/user.png"} />
          },
          // {
          //   title: "Patient ID",
          //   dataIndex: "patientID",
          //   key: "patientID",
          //   sorter: (a, b) => a.patientID.toString().localeCompare(b.patientID),
          // },
          {
            title: "Name", dataIndex: "patientName", key: "patientName",
            sorter: (a, b) => a.patientName.localeCompare(b.patientName),
          },
          {
            title: "Mobile", dataIndex: "mobile", key: "mobile",
            sorter: (a, b) => a.mobile.localeCompare(b.mobile),
          },
          { title: "Age", dataIndex: "age", key: "age" },
          { title: "Gender", dataIndex: "gender", key: "gender" },
          {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
              <div className="flex gap-3">
                <Button type="primary" onClick={() => viewDetails(record, "patient")}>
                  View Details
                </Button>
                <Button
                  type="default"
                  className="ml-2 flex items-center gap-1 justify-center"
                  icon={<FaEdit className="mr-2 h-4 w-4" />}
                  onClick={() => {
                    toast.info("Ask admin for edit.");
                  }}
                >
                  Edit
                </Button>
              </div>
            )
          },
        ];
        data = await ensureData("patient");
        break;
      default:
        columns = [];
        data = [];
    }

    setModalColumns(columns);
    setModalData(data);
    setModalLoading(false);
  };

  const viewDetails = (record, type) => {
    setSelectedRecord(record);
    setCurrentView("details");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentView("table");
    setSelectedRecord(null);
  };

  const backToTable = () => {
    setCurrentView("table");
    setSelectedRecord(null);
  };

  const renderDetailsView = (record, type) => {
    if (!record) return null;

    switch (type) {
      case "doctor":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <Avatar
                src={record.image || "/user.png"}
                size={100}
              />
              <h2>{record.docName || '-'}</h2>
              <p>{record.department || '-'}</p>
            </div>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Doctor ID">{record.docID || '-'}</Descriptions.Item>
              <Descriptions.Item label="Email">{record.email || '-'}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.mobile || '-'}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.age || '-'}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.gender || '-'}</Descriptions.Item>
              <Descriptions.Item label="Date of Birth">{record.DOB || '-'}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address || '-'}</Descriptions.Item>
              <Descriptions.Item label="Education">{record.education || '-'}</Descriptions.Item>
              <Descriptions.Item label="Details" span={2}>{record.details || '-'}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      case "manager":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <Avatar
                src={record.image || "/user.png"}
                size={100}
              />
              <h2>{record.managerName}</h2>
            </div>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="manager ID">{record.managerID}</Descriptions.Item>
              <Descriptions.Item label="Email">{record.email}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.mobile}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.age}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.gender}</Descriptions.Item>
              <Descriptions.Item label="Blood Group">{record.bloodGroup}</Descriptions.Item>
              <Descriptions.Item label="Date of Birth">{record.DOB}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address}</Descriptions.Item>
              <Descriptions.Item label="Education">{record.education}</Descriptions.Item>
              <Descriptions.Item label="Details" span={2}>{record.details}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      case "agent":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <Avatar
                src={record.image || "/user.png"}
                size={100}
              />
              <h2>{record.name}</h2>
              <Tag color={record.status === 'active' ? 'green' : 'red'}>
                {record.status?.toUpperCase() || "ACTIVE"}
              </Tag>
            </div>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Agent ID">{record.agentID}</Descriptions.Item>
              <Descriptions.Item label="Email">{record.email}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.mobile}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.age}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.gender}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address}</Descriptions.Item>
              {/* <Descriptions.Item label="Commission Rate">{record.commissionRate}%</Descriptions.Item> */}
              <Descriptions.Item label="Status">{record.status}</Descriptions.Item>
              <Descriptions.Item label="Referrals">{record.referrals}</Descriptions.Item>
              {/* <Descriptions.Item label="Total Commission">₹{record.totalCommission}</Descriptions.Item> */}
              <Descriptions.Item label="Date Joined">{new Date(record.dateJoined).toLocaleDateString()}</Descriptions.Item>
              <Descriptions.Item label="Notes" span={2}>{record.notes}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      case "admin":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <Avatar
                src={record.image || "/user.png"}
                size={100}
              />
              <h2>{record.adminName || "Admin"}</h2>
            </div>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Admin ID">{record.adminID || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Email">{record.email || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.mobile || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.age || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.gender || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Date of Birth">{record.DOB || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Education">{record.education || "N/A"}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      case "testorder":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <h2>Test Orders Details for {record.patient?.patientName}</h2>
              <p>Date: {record.date} | Time: {record.time}</p>
            </div>
            <Descriptions bordered column={2}>
              <Descriptions.Item label="Test Order ID">{record.testOrderID || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Patient Name">{record.patient?.patientName || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.patient?.age || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.patient?.gender || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Email">{record.patient?.email || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.patient?.mobile || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Doctor">{record.doctor?.docName || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Agent">{record.agent?.agentName || "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address || "N/A"}</Descriptions.Item>
            </Descriptions>

            <h3 style={{ marginTop: 20 }}>Tests</h3>
            <Table
              dataSource={record.tests?.map((test, index) => ({ ...test, key: index })) || []}
              columns={[
                { title: "Test Name", dataIndex: "test", key: "test", render: (test) => test?.test?.title || test?.title || "N/A" },
                { title: "Price", dataIndex: "testPrice", key: "testPrice", render: (price) => `₹${price}` }
              ]}
              pagination={false}
            />

            <h3 style={{ marginTop: 20 }}>Revenue Distribution</h3>
            <Descriptions bordered column={3}>
              <Descriptions.Item label="Total Amount">₹{record.totalAmount}</Descriptions.Item>
              <Descriptions.Item label="Hospital Revenue">₹{record.hospitalRevenue}</Descriptions.Item>
              <Descriptions.Item label="Doctor Revenue">₹{record.doctorRevenue}</Descriptions.Item>
              <Descriptions.Item label="Agent Revenue">₹{record.agentRevenue}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      case "patient":
        return (
          <div>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <Avatar
                src={record.image || "/user.png"}
                size={100}
              />
              <h2>{record.patientName}</h2>
              <p>{record.disease}</p>
            </div>
            <Descriptions bordered column={2}>
              {/* <Descriptions.Item label="Patient ID">{record.patientID}</Descriptions.Item> */}
              <Descriptions.Item label="Email">{record.email}</Descriptions.Item>
              <Descriptions.Item label="Mobile">{record.mobile}</Descriptions.Item>
              <Descriptions.Item label="Age">{record.age}</Descriptions.Item>
              <Descriptions.Item label="Gender">{record.gender}</Descriptions.Item>
              <Descriptions.Item label="Address">{record.address}</Descriptions.Item>
            </Descriptions>
          </div>
        );
      default:
        return <div>No details available</div>;
    }
  };

  const dashboardCards = [
    {
      title: "Doctor",
      count: summaryCounts.doctor ?? data?.doctor ?? doctors.length ?? 0,
      icon: <MdPersonAdd className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-blue-500 to-blue-600",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      onClick: () => showModal("Doctor Details", "doctor")
    },
    {
      title: "Manager",
      count: summaryCounts.manager ?? data?.manager ?? managers.length ?? 0,
      icon: <FaHospitalUser className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-green-500 to-green-600",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      onClick: () => showModal("Manager Details", "manager")
    },
    {
      title: "Agent",
      count: summaryCounts.agent ?? agents.length ?? 0,
      icon: <RiEmpathizeLine className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-purple-500 to-purple-600",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      onClick: () => showModal("Agent Details", "agent")
    },
    {
      title: "Admin",
      count: summaryCounts.admin ?? data?.admin ?? admins.length ?? 0,
      icon: <RiAdminLine className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-orange-500 to-orange-600",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-600",
      onClick: () => showModal("Admin Details", "admin")
    },
    {
      title: "Test Orders",
      count: summaryCounts.testorder ?? data?.testorder ?? testorders.length ?? 0,
      icon: <BsFillBookmarkCheckFill className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-teal-500 to-teal-600",
      iconBg: "bg-teal-100",
      iconColor: "text-teal-600",
      onClick: () => showModal("Testorder Details", "testorder")
    },
    {
      title: "Patients",
      count: summaryCounts.patient ?? patients.length ?? 0,
      icon: <MdOutlineBedroomParent className="text-4xl" />,
      bgColor: "bg-gradient-to-br from-pink-500 to-pink-600",
      iconBg: "bg-pink-100",
      iconColor: "text-pink-600",
      onClick: () => showModal("Patient Details", "patient")
    }
  ];

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar onCollapse={setSidebarCollapsed} />
      <div className={` flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'
        }`}>
        <div className="flex-1 p-6 ml-40">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Dashboard Overview</h1>
            <p className="text-gray-600">Monitor your healthcare management system</p>
          </div>

          {loading ? (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <Spin size="large" />
                <p className="mt-4 text-gray-600">Loading dashboard data...</p>
              </div>
            </div>
          ) : (
            <>
              {/* Test Search Field (always visible) */}
              {/* Removed global test search field, filtering is now per-table in modal */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
                {dashboardCards.map((card, index) => (
                  <div
                    key={index}
                    onClick={card.onClick}
                    className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer transform hover:-translate-y-1"
                  >
                    <div className="p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <h3 className="text-2xl font-bold text-gray-800 mb-1">
                            {card.count}
                          </h3>
                          <p className="text-gray-600 text-sm font-medium">
                            {card.title}
                          </p>
                        </div>
                        <div className={`p-3 rounded-full ${card.iconBg}`}>
                          <div className={card.iconColor}>
                            {card.icon}
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div className={`h-1 rounded-full ${card.bgColor}`}></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          <Modal
            title={
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-4 justify-between mr-6">
                  <span className="text-lg font-semibold text-gray-800">{modalTitle}</span>
                  <input
                    type="text"
                    placeholder="Filter table by text..."
                    value={modalFilterText}
                    onChange={e => setModalFilterText(e.target.value)}
                    style={{ width: 300, padding: 8, border: '1px solid #ccc', borderRadius: 4 }}
                  />
                </div>
              </div>
            }
            open={isModalVisible}
            onCancel={handleCancel}
            footer={
              currentView === "table"
                ? [
                  <Button key="back" onClick={handleCancel} className="bg-gray-500 hover:bg-gray-600">
                    Close
                  </Button>
                ]
                : [
                  <Button key="back" onClick={backToTable} className="bg-blue-500 hover:bg-blue-600">
                    Back to List
                  </Button>,
                  <Button key="close" onClick={handleCancel} className="bg-gray-500 hover:bg-gray-600">
                    Close
                  </Button>
                ]
            }
            width={currentView === "details" ? 800 : 1000}
            className="custom-modal"
          >
            {modalLoading ? (
              <div className="flex items-center justify-center py-8">
                <div className="text-center">
                  <Spin size="large" />
                  <p className="mt-4 text-gray-600">Loading data...</p>
                </div>
              </div>
            ) : currentView === "table" ? (
              <Table
                columns={modalColumns}
                dataSource={(modalData || [])
                  .filter(item => {
                    if (!modalFilterText) return true;
                    const text = modalFilterText.toLowerCase();
                    return Object.values(item).some(val =>
                      val && val.toString().toLowerCase().includes(text)
                    );
                  })
                  .map((item, index) => ({ ...item, key: index }))}
                pagination={{ pageSize: 5 }}
                className="custom-table"
              />
            ) : (
              <div className="bg-white rounded-lg">
                {renderDetailsView(selectedRecord, modalTitle.split(" ")[0].toLowerCase())}
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default FrontPage;
